export default __webpack_public_path__ + "static/media/completed.0fb03533.svg";